export const indice =  (numPagina = 1, filas = 0) => [
    {
      field: "index",
      headerName: "N°",
      width: 70,
      valueGetter: (params) => {
        return (numPagina - 1) * filas + params.api.getRowIndex(params.row.id) + 1;
      },
    },
  ];
  